<!-- PACIENTE -->
<div class="card h-100 p-0 m-0" 
     [ngClass]="{'border-card': data.tel_doc_app_boo_is_ondemand == false, 'border-card-ondemand': data.tel_doc_app_boo_is_ondemand == true}">

  <!-- Encabezado con el Badge -->
  <div class="card-header p-0">
    <div class="row p-0">
      <span *ngIf="!data.tel_doc_app_boo_is_ondemand" class="badge badge-primary align-self-start badge-color">
        Agendamiento
      </span>
      <span *ngIf="data.tel_doc_app_boo_is_ondemand" class="badge badge-primary align-self-start badge-color-ondemand">
        Atención Inmediata
      </span>
    </div>
  </div>

  <!-- Contenido principal -->
  <div class="row card-block px-2 px-sm-3 pt-2 pt-sm-3 pb-3 align-items-center" style="width: 100%;">
    
    <!-- Imagen y Datos del Médico -->
    <div class="col-lg-6 col-md-6 col-sm-12 d-flex align-items-center ">
      <app-profile-img [img]="data.consulta.att_path"></app-profile-img>
      <div class="ml-3 align-self-center">
        <p class="card-text m-0 p-0 appt-date">{{ data.date[0] }} {{ data.date[1] }}</p>
        <p class="card-text pt-3 mr-5 doc-data">{{ data.doctorName }} {{ data.doctorLastName }} - {{ data.spec }}</p>
      </div>
    </div>

    <!-- Estado y Botón -->
    <div class="col-lg-6 col-md-6 col-sm-12 d-flex flex-column align-items-md-end align-items-center">
      <div class="row w-100" style="align-items: center;">
        
        <!-- Estados -->
        <div class="col-md-7 col-sm-6 text-md-right text-center">
          <p class="card-text flag-helper appt-gris">*{{data.sta_name}}</p>
          
        </div>
    
        <!-- Botón Ver Detalle -->
        <div class="col-md-5 col-sm-6 text-md-right text-center mt-2 mt-md-0">
          <button type="button" class="btn btn-primary"
            (click)="verDetalle()"
            [ngStyle]="{'background-color': data.tel_doc_app_boo_is_ondemand ? '#2BABB7' : '#316AD8'}">
            Ver detalle
          </button>
        </div>
    
      </div>
    </div>
    
  </div>
</div>
